import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
} from '@chakra-ui/react';
import type { MVRProductType } from 'api';

interface MvrFleetGarageAdvisoryProps {
  show: boolean;
  productType: Extract<MVRProductType, 'fleet' | 'garage'>;
  isOverridden: boolean;
  onOverride: () => void;
}

const ADVISORY_BODY =
  'The carrier underwriter typically pulls MVRs as part of the underwriting process. MVRs do not need to be requested here unless the carrier underwriter has requested them in order to quote/bind. Please review and confirm with your client that all driving history has been disclosed accurately, as premium, coverage, rating, and eligibility may be subject to change following carrier review.';

const ADVISORY_HEADING: Record<'fleet' | 'garage', string> = {
  fleet: 'Fleet Business Advisory',
  garage: 'Garage Business Advisory',
};

const OVERRIDE_BUTTON_LABEL = 'Carrier UW requested MVRs from Broker';

const MvrFleetGarageAdvisory = ({
  show,
  productType,
  isOverridden,
  onOverride,
}: MvrFleetGarageAdvisoryProps) => {
  if (!show) return null;

  if (isOverridden) {
    return (
      <Box mb={4}>
        <Alert status="success" variant="subtle" borderRadius="md">
          <AlertIcon />
          <AlertDescription>
            Acknowledged — carrier UW requested MVRs from broker.
          </AlertDescription>
        </Alert>
      </Box>
    );
  }

  return (
    <Box mb={4}>
      <Alert
        status="error"
        borderRadius="md"
        flexDirection="column"
        alignItems="flex-start"
      >
        <Box display="flex" alignItems="center">
          <AlertIcon />
          <AlertTitle>{ADVISORY_HEADING[productType]}</AlertTitle>
        </Box>
        <AlertDescription mt={2}>{ADVISORY_BODY}</AlertDescription>
        <Button size="sm" mt={3} onClick={onOverride}>
          {OVERRIDE_BUTTON_LABEL}
        </Button>
      </Alert>
    </Box>
  );
};

export default MvrFleetGarageAdvisory;
